import { render, staticRenderFns } from "./AdminTop.vue?vue&type=template&id=767a09e3&scoped=true"
import script from "./AdminTop.vue?vue&type=script&lang=js"
export * from "./AdminTop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767a09e3",
  null
  
)

export default component.exports